import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "grid gap-2" }
const _hoisted_3 = { class: "flex items-center" }

import InputError from '@/components/InputError.vue';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import AuthLayout from '@/layouts/AuthLayout.vue';
import { Head, useForm } from '@inertiajs/vue3';
import { LoaderCircle } from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmPassword',
  setup(__props) {

const form = useForm({
    password: '',
});

const submit = () => {
    form.post(route('password.confirm'), {
        onFinish: () => {
            form.reset();
        },
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthLayout, {
    title: "Confirm your password",
    description: "This is a secure area of the application. Please confirm your password before continuing."
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Head), { title: "Confirm password" }),
      _createElementVNode("form", {
        onSubmit: _withModifiers(submit, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(Label), { htmlFor: "password" }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Password")
              ])),
              _: 1,
              __: [1]
            }),
            _createVNode(_unref(Input), {
              id: "password",
              type: "password",
              class: "mt-1 block w-full",
              modelValue: _unref(form).password,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).password) = $event)),
              required: "",
              autocomplete: "current-password",
              autofocus: ""
            }, null, 8, ["modelValue"]),
            _createVNode(InputError, {
              message: _unref(form).errors.password
            }, null, 8, ["message"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Button), {
              class: "w-full",
              disabled: _unref(form).processing
            }, {
              default: _withCtx(() => [
                (_unref(form).processing)
                  ? (_openBlock(), _createBlock(_unref(LoaderCircle), {
                      key: 0,
                      class: "h-4 w-4 animate-spin"
                    }))
                  : _createCommentVNode("", true),
                _cache[2] || (_cache[2] = _createTextVNode(" Confirm Password "))
              ]),
              _: 1,
              __: [2]
            }, 8, ["disabled"])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }))
}
}

})